const RecipientsNameSpace = 'recipients';

const RecipientsActionTypes = Object.freeze({
    GetRecipients: 'GetRecipients',
    GetRecipient: 'GetRecipient',
    AddRecipient: 'AddRecipient',
    AddRecipientProfile: 'AddRecipientProfile',
    EditRecipient: 'EditRecipient',
    SetRecipientPromotion: 'SetRecipientPromotion',
    SetRecipientGroup: 'SetRecipientGroup',
    EditRecipientProfile: 'EditRecipientProfile',
    DeleteRecipient: 'DeleteRecipient',
    FindRecipient: 'FindRecipient',
});

const RecipientsMutationTypes = Object.freeze({
    SetRecipients: 'SetRecipients',
    SetChangedRecipient: 'SetRecipient',
    SetDeletedRecipient: 'SetDeletedRecipient',
    SetEmptyRecipients: 'SetEmptyRecipients',
});

const RecipientsGetterTypes = Object.freeze({
    GetRecipients: 'GetRecipients',
    GetResponse: 'GetResponse',
    GetPerPage: 'GetPerPage',
});

export {
    RecipientsNameSpace,
    RecipientsActionTypes,
    RecipientsMutationTypes,
    RecipientsGetterTypes,
};